/**
 * Celeste Dice SVG Data
 *
 * SVG paths, diamond geometry, and layout data for the celeste dice design.
 * Background paths extracted from the blue_1 reference SVG (shared across all colors).
 * Diamond positions derived from Figma exports for values 1, 2, 5, 6;
 * values 3 and 4 interpolated using standard dice face patterns.
 */

// ─── SVG Paths (from blue_1 reference) ────────────────────────────────

export const CELESTE_PATHS = {
  DARK_SHADOW:
    'M12.72 137.81V163.24C12.72 170.68 14.8 177.63 18.21 181.15C18.24 181.18 18.26 181.21 18.29 181.23C22.25 185.25 25.99 184.32 30.51 183.92C36.02 183.43 41.53 184.98 47.04 184.98C58.03 184.98 69.01 185.01 80 184.98C87.9 184.96 95.67 184.98 101.24 184.98C109.76 184.99 114.02 185 114.46 185.02C133.18 185.58 134.67 188.01 141.31 185.02C145.9 182.95 147.54 180.73 151.83 180.85C155.89 180.96 158.49 183.06 161.85 180.47C164.59 178.35 166.56 173.36 166.56 173.36C166.56 173.35 166.57 173.34 166.58 173.32C167.38 171.55 167.79 169.26 167.78 166.92C167.72 155.87 167.67 144.82 167.61 133.78C142.86 140.91 114.12 146.02 82.13 145.98C56.7 145.95 33.43 142.68 12.73 137.81H12.72Z',
  SILVER_LEDGE:
    'M12.7 128.54V162.1C13.76 165.12 15.53 169.18 18.28 171.96C22.24 175.98 25.98 175.05 30.5 174.65C36.01 174.16 41.52 175.71 47.03 175.71C58.02 175.71 69 175.74 79.99 175.71C87.89 175.69 95.66 175.71 101.23 175.71C109.75 175.72 114.01 175.73 114.45 175.75C133.17 176.31 134.66 178.74 141.29 175.75C145.88 173.68 147.52 171.46 151.81 171.58C155.87 171.69 158.47 173.79 161.83 171.2C164.57 169.08 166.54 164.09 166.54 164.09C167.09 162.87 167.5 161.76 167.78 160.95C167.72 148.8 167.66 136.65 167.6 124.51C142.85 131.64 114.11 136.75 82.12 136.71C56.69 136.68 33.42 133.41 12.72 128.54H12.7Z',
  BODY_RECT:
    'M148.01 13.78H32.76C21.8524 13.78 13.01 22.6224 13.01 33.53V148.78C13.01 159.688 21.8524 168.53 32.76 168.53H148.01C158.918 168.53 167.76 159.688 167.76 148.78V33.53C167.76 22.6224 158.918 13.78 148.01 13.78Z',
  CLOUD_BOTTOM:
    'M18.53 133.23C18.53 123.37 29.85 115.37 43.81 115.37C46.71 115.37 49.49 115.72 52.08 116.35C52.75 108.21 60.39 101.79 69.73 101.79C77.37 101.79 83.88 106.09 86.36 112.12C88.65 111.46 91.14 111.1 93.75 111.1C104.92 111.1 113.98 117.72 113.98 125.88C113.98 127.36 113.68 128.79 113.13 130.14C121.29 133.05 126.94 139.32 126.94 146.6C126.94 156.64 116.19 164.77 102.92 164.77C95.07 164.77 88.1 161.92 83.72 157.52C79.54 159.25 74.52 160.26 69.1 160.26C58.63 160.26 49.59 156.49 45.38 151.06C44.86 151.09 44.34 151.1 43.81 151.1C29.85 151.1 18.53 143.11 18.53 133.24V133.23Z',
  CLOUD_RIGHT:
    'M167.76 126.89V138.75C167.39 138.92 167 139.08 166.59 139.21C164 140.06 161.4 139.88 159.48 138.91C158.29 139.93 156.74 140.8 154.96 141.39C151.51 142.53 148.13 142.26 146.16 140.93C145.99 140.99 145.82 141.05 145.64 141.11C141.05 142.62 136.45 141.22 135.38 137.97C134.32 134.72 137.18 130.87 141.78 129.35C142.73 129.04 143.68 128.85 144.6 128.78C143.94 126.03 145.76 123.08 148.84 122.07C151.35 121.24 153.96 121.96 155.43 123.67C156.11 123.21 156.89 122.82 157.75 122.53C161.43 121.32 165.13 122.52 166.02 125.21C166.18 125.7 166.23 126.2 166.2 126.71C166.74 126.72 167.26 126.78 167.76 126.89Z',
  CLOUD_TOP_RIGHT:
    'M38.87 81.3501C38.07 78.9201 40.21 76.0301 43.66 74.8901C44.37 74.6501 45.09 74.5101 45.78 74.4601C45.28 72.4001 46.65 70.1901 48.95 69.4301C50.84 68.8101 52.79 69.3401 53.89 70.6301C54.4 70.2801 54.99 69.9901 55.63 69.7801C58.39 68.8701 61.16 69.7801 61.82 71.7901C61.94 72.1601 61.98 72.5301 61.96 72.9101C64.21 72.9601 66.11 74.0601 66.7 75.8501C67.51 78.3301 65.52 81.2101 62.25 82.2801C60.31 82.9201 58.36 82.7801 56.92 82.0501C56.03 82.8201 54.87 83.4701 53.54 83.9101C50.96 84.7601 48.42 84.5601 46.94 83.5601C46.81 83.6101 46.69 83.6501 46.56 83.7001C43.11 84.8301 39.67 83.7801 38.87 81.3501Z',
  CLOUD_TOP_LEFT:
    'M49.38 56.08C45.45 57.38 41.49 57.1 38.58 55.62C36.77 57.17 34.42 58.5 31.71 59.39C26.47 61.12 21.33 60.72 18.33 58.69C18.07 58.79 17.81 58.88 17.55 58.97C16.01 59.48 14.48 59.76 13.01 59.85V40.72C14.01 40.46 15 40.3 15.96 40.22C14.96 36.04 17.73 31.56 22.4 30.03C26.22 28.77 30.19 29.85 32.42 32.46C33.46 31.75 34.65 31.16 35.95 30.73C41.55 28.89 47.17 30.71 48.51 34.8C48.76 35.54 48.84 36.3 48.79 37.07C53.35 37.18 57.21 39.39 58.41 43.03C60.06 48.06 56.02 53.9 49.38 56.08Z',
  WHITE_FACE:
    'M132.31 29.51H48.16C37.2524 29.51 28.41 38.3524 28.41 49.26V132.56C28.41 143.468 37.2524 152.31 48.16 152.31H132.31C143.218 152.31 152.06 143.468 152.06 132.56V49.26C152.06 38.3524 143.218 29.51 132.31 29.51Z',
  WHITE_FACE_HORIZ:
    'M28.41 49.64L28.41 132.94C28.41 143.848 37.2524 152.69 48.16 152.69H132.31C143.218 152.69 152.06 143.848 152.06 132.94V49.64C152.06 38.7324 143.218 29.89 132.31 29.89H48.16C37.2524 29.89 28.41 38.7324 28.41 49.64Z'
} as const;

// ─── Gradient Definitions ─────────────────────────────────────────────

export const CELESTE_GRADIENTS = {
  SHADOW: { x1: 90.24, y1: 176.02, x2: 90.24, y2: 185.98, start: '#333333', end: '#1A1A1A' },
  LEDGE: { x1: 90.23, y1: 167.78, x2: 90.23, y2: 189.56, start: '#F2F2F2', end: '#808080' },
  BODY: {
    x1: 90.39,
    y1: 13.78,
    x2: 90.39,
    y2: 168.53,
    stops: ['#72BBFC', '#A7DFFC', '#E6FBFF'] as const
  },
  CLOUD_BOTTOM: { x1: 18.53, y1: 133.28, x2: 126.93, y2: 133.28 },
  CLOUD_RIGHT: { x1: 167.76, y1: 131.92, x2: 135.16, y2: 131.92 },
  CLOUD_TOP_RIGHT: { x1: 38.629, y1: 81.0714, x2: 65.3786, y2: 72.2714 },
  CLOUD_TOP_LEFT: { x1: 58.78, y1: 45, x2: 13.01, y2: 45 },
  WHITE_VERT: { x1: 90.23, y1: 26.82, x2: 90.23, y2: 155.24 },
  WHITE_HORIZ: { x1: 25.7, y1: 91.29, x2: 155.01, y2: 91.29 },
  WHITE_BORDER: { color: '#B3B3B3', transparent: 'white' }
} as const;

// Texture rect position
export const TEXTURE_RECT = { x: -24.18, y: -23.19, width: 229, height: 229 } as const;

// ─── Diamond Star Geometry ────────────────────────────────────────────

// Indent ratio: controls the "pointiness" of the 4-pointed star (consistent across all sizes)
const INDENT_RATIO = 0.27;
// Inner diamond is 84.5% the size of the outer
const INNER_SCALE = 0.845;

type DiamondSize = 'large' | 'medium' | 'small';

const DIAMOND_EXTENTS: Record<DiamondSize, number> = {
  large: 46.58,
  medium: 23.53,
  small: 16.52
};

export interface DiamondLayout {
  cx: number;
  cy: number;
  size: DiamondSize;
}

/**
 * Diamond center positions per dice value.
 * Values 1, 2, 5, 6: from Figma SVG exports
 * Values 3, 4: interpolated using standard dice face patterns
 */
export const DIAMOND_LAYOUTS: Record<number, DiamondLayout[]> = {
  0: [],
  1: [{ cx: 90.23, cy: 90.44, size: 'large' }],
  2: [
    { cx: 116.46, cy: 66.08, size: 'medium' },
    { cx: 62.99, cy: 119.55, size: 'medium' }
  ],
  3: [
    { cx: 116.46, cy: 66.08, size: 'medium' },
    { cx: 90.23, cy: 90.44, size: 'medium' },
    { cx: 62.99, cy: 119.55, size: 'medium' }
  ],
  4: [
    { cx: 58.72, cy: 58.14, size: 'medium' },
    { cx: 125.08, cy: 58.14, size: 'medium' },
    { cx: 58.72, cy: 123.2, size: 'medium' },
    { cx: 125.08, cy: 123.2, size: 'medium' }
  ],
  5: [
    { cx: 58.72, cy: 58.14, size: 'medium' },
    { cx: 125.08, cy: 58.14, size: 'medium' },
    { cx: 92.21, cy: 91.49, size: 'medium' },
    { cx: 58.72, cy: 123.2, size: 'medium' },
    { cx: 125.08, cy: 123.2, size: 'medium' }
  ],
  6: [
    { cx: 65.57, cy: 50.29, size: 'small' },
    { cx: 119.7, cy: 48.88, size: 'small' },
    { cx: 65.57, cy: 87.45, size: 'small' },
    { cx: 119.7, cy: 86.04, size: 'small' },
    { cx: 65.57, cy: 123.35, size: 'small' },
    { cx: 119.7, cy: 121.94, size: 'small' }
  ]
};

/**
 * Generate an 8-point star path (4-pointed diamond star).
 * The star has 4 cardinal points at `extent` distance from center
 * and 4 diagonal points at `indent` distance from center.
 */
export function generateStarPath(cx: number, cy: number, extent: number): string {
  const indent = extent * INDENT_RATIO;
  const tr = `${String(cx + indent)} ${String(cy - indent)}`;
  const t = `${String(cx)} ${String(cy - extent)}`;
  const tl = `${String(cx - indent)} ${String(cy - indent)}`;
  const l = `${String(cx - extent)} ${String(cy)}`;
  const bl = `${String(cx - indent)} ${String(cy + indent)}`;
  const b = `${String(cx)} ${String(cy + extent)}`;
  const br = `${String(cx + indent)} ${String(cy + indent)}`;
  const r = `${String(cx + extent)} ${String(cy)}`;
  return `M${tr}L${t}L${tl}L${l}L${bl}L${b}L${br}L${r}Z`;
}

/** Generate outer diamond star path for a layout entry */
export function outerDiamondPath(layout: DiamondLayout): string {
  return generateStarPath(layout.cx, layout.cy, DIAMOND_EXTENTS[layout.size]);
}

/** Generate inner diamond star path for a layout entry */
export function innerDiamondPath(layout: DiamondLayout): string {
  return generateStarPath(layout.cx, layout.cy, DIAMOND_EXTENTS[layout.size] * INNER_SCALE);
}
